import React, { useMemo, useState } from "react"
import { useForm } from "QuorumGrassroots/campaign-forms/hooks/useForm"
import { QuestionsContainer } from "QuorumGrassroots/campaign-forms/components/PersonalizedMessages/components/QuestionsContainer"
import { InformationContainer } from "QuorumGrassroots/campaign-forms/components/PersonalizedMessages/components/InformationContainer"
import {
    getFormDefaultValues,
    PromptAndResponseCampaignForm,
    validateFormValues,
} from "QuorumGrassroots/campaign-forms/components/PersonalizedMessages/PersonalizedMessages.helper"
import { SendMessageContainer } from "QuorumGrassroots/campaign-forms/components/PersonalizedMessages/components/SendMessageContainer"
import { Container } from "QuorumGrassroots/campaign-forms/components/PersonalizedMessages/PersonalizedMessages.styles"
import { usePersonalizedCampaignGetCampaignMessages } from "QuorumGrassroots/services"
import { StyledContrastText } from "QuorumGrassroots/styled-components/components/StyledContrastText"
import {
    AnimationContainer,
    useAnimation,
    ANIMATION_OUT_DURATION,
} from "QuorumGrassroots/campaign-forms/components/StepAnimation"

export enum Contents {
    information,
    questions,
    sendMessage,
}

const CONTENTS_MAPPER = {
    [Contents.information]: InformationContainer,
    [Contents.questions]: QuestionsContainer,
    [Contents.sendMessage]: SendMessageContainer,
}

export const PersonalizedMessages = (props) => {
    const [currentContentName, setCurrentContentName] = useState(Contents.information)
    const messagesQuery = usePersonalizedCampaignGetCampaignMessages(String(props.campaign.id))
    const { animate, shouldAnimate } = useAnimation()

    const questions = useMemo(() => {
        return props?.campaign?._extra?.personalized_campaign_pages?.[0] ?? []
    }, [props?.campaign?._extra?.personalized_campaign_pages])

    const form = useForm<PromptAndResponseCampaignForm>(
        getFormDefaultValues(props?.campaign),
        (values) => validateFormValues(values, questions),
        true,
    )

    const ContentComponent = CONTENTS_MAPPER[currentContentName]

    const handleChangeContent = (newContent) => {
        animate()
        setTimeout(() => {
            setCurrentContentName(newContent)
        }, ANIMATION_OUT_DURATION)
    }

    if (messagesQuery.isLoading && currentContentName === Contents.sendMessage) {
        return <StyledContrastText isCampaignPage>Loading...</StyledContrastText>
    }

    if (messagesQuery.isError && currentContentName === Contents.sendMessage) {
        return <StyledContrastText isCampaignPage>Something went wrong</StyledContrastText>
    }

    return (
        <Container isSingleColumnLayout>
            <AnimationContainer shouldAnimate={shouldAnimate} disableFirstAnimation>
                <ContentComponent
                    form={form}
                    questions={questions}
                    handleChangeContent={handleChangeContent}
                    {...props}
                />
            </AnimationContainer>
        </Container>
    )
}
